import React, { Component } from 'react'
import { Button } from "react-bootstrap";
import gql from "graphql-tag";
import { withApollo } from "react-apollo";
import * as Cookies from "es-cookie";
import CardLessDataTableWithOutSearch from '../datatables/CardLessDataTableWithOutSearch';
import CreateRoleModal from './CreateRoleModal';
import { TableShimmer } from '../preloader/PageCardShimmer';
import { attachModuleGuard, AccessDeniedModal } from "../../../utils/moduleGuard";

// Rows in roleModuleAccess match on module_key OR module_name — pass both spellings.
const EMPLOYEE_RESTRICTIONS_MODULE = ["Employee_Restrctions", "staff"];
// This is the Roles tab. module_key "Employee_Restrctions" has separate rows per
// sub_module_name ("employees" / "roles" / "module-access"); scope to "roles" so this
// tab reads only its own grant and the other tabs' grants can't leak in.
const EMPLOYEE_RESTRICTIONS_SUB = "roles";

// NOTE: assumed backend operation — confirm/adjust name + fields with your API.
const GET_EMPLOYEE_ROLES = gql`
  query($institute_id: Int) {
    getEmployeeRoles(institute_id: $institute_id) {
      id
      role_name
      description
      is_mandatory
      is_attendance
    }
  }
`;

class RolesTab extends Component {
    constructor(props) {
        super(props);
        this.state = {
            roles: [],
            loading: true,
            roleModalShow: false,
            editRole: null,
            // Flipped to true by the guard when a role without is_edit clicks Create / Edit.
            accessDeniedShow: false,
        };

        // Scoped to the "roles" sub-module. The Create / Edit controls stay VISIBLE; the
        // guard intercepts the click and opens the Access Denied modal without the grant.
        this.guard = attachModuleGuard(this, EMPLOYEE_RESTRICTIONS_MODULE, EMPLOYEE_RESTRICTIONS_SUB);
    }

    componentDidMount() {
        this.getRoles();
    }

    getRoles = async () => {
        try {
            const result = await this.props.client.query({
                query: GET_EMPLOYEE_ROLES,
                variables: { institute_id: parseInt(Cookies.get("institutionid")) },
                fetchPolicy: "network-only",
            });
            this.setState({ roles: (result.data && result.data.getEmployeeRoles) || [], loading: false });
        } catch {
            // backend may not be ready yet — show empty state instead of breaking the page
            this.setState({ roles: [], loading: false });
        }
    };

    // is_edit gate for opening the edit modal — pops Access Denied if the grant is missing.
    handleEditRole = (row) => {
        if (!this.guard.requireEdit()) return;
        this.setState({ roleModalShow: true, editRole: row });
    };

    // is_edit gate for opening the create modal.
    handleCreateRole = () => {
        if (!this.guard.requireEdit()) return;
        this.setState({ roleModalShow: true, editRole: null });
    };

    articlecolumns = [
        {
            dataField: "#",
            text: "#",
            formatter: (cell, row, rowIndex) => rowIndex + 1,
        },
        {
            dataField: "role_name",
            text: "Role Name",
            sort: true,
        },
        {
            dataField: "description",
            text: "Description",
            formatter: (cell) => cell || "--",
        },
        {
            dataField: "edit",
            text: "Edit",
            // Mandatory roles are never editable (a data rule, not a permission) → show "--".
            // For every other role the Edit icon is always shown; the click runs the guard,
            // which opens Access Denied when the role lacks is_edit.
            formatter: (cell, row) => (
                row.is_mandatory ? (
                    <span style={{ color: "#cbd5e1" }}>--</span>
                ) : (
                    <div className="actions-buttons d-flex justify-content-center align-items-top" onClick={() => this.handleEditRole(row)}>
                        <Button variant="link" name="edit" className="text-theme">
                            <i className="far fa-edit" />
                        </Button>
                    </div>
                )
            ),
        },
    ];

    render() {
        const FIN = {
            card: { background: "#fff", borderRadius: 16, boxShadow: "0 4px 24px rgba(0,0,0,0.05)", overflow: "visible", border: "1px solid #e2e8f0" },
            cardHeader: { background: "#ffffff", padding: "20px 24px", display: "flex", alignItems: "center", gap: 14, borderBottom: "1px solid #f1f5f9", flexWrap: "wrap" },
            iconWrapper: { width: 38, height: 38, borderRadius: 10, background: "#f5f3ff", border: "1px solid #ddd6fe", display: "flex", alignItems: "center", justifyContent: "center", color: "#7c3aed", fontSize: 16, flexShrink: 0 },
            cardTitleText: { display: "flex", flexDirection: "column", textAlign: "left" },
            cardTitle: { color: "#0f172a", fontWeight: 700, fontSize: 16, margin: 0, letterSpacing: "-0.01em" },
            cardSubtitle: { color: "#64748b", fontSize: 12, fontWeight: 500, marginTop: 2 },
            headerActions: { display: "flex", gap: 10, marginLeft: "auto", flexWrap: "wrap" },
            btnPrimary: { display: "inline-flex", alignItems: "center", justifyContent: "center", gap: 7, background: "#7c3aed", color: "#fff", border: "none", borderRadius: 9, padding: "10px 16px", fontSize: 13, fontWeight: 600, cursor: "pointer", height: 42 },
            content: { padding: "20px 24px" },
            empty: { padding: "40px 24px", textAlign: "center", color: "#94a3b8", fontSize: 13 },
        };

        return (
            <div style={FIN.card}>
                <div style={FIN.cardHeader}>
                    <div style={FIN.iconWrapper}><i className="fal fa-user-tag" /></div>
                    <div style={FIN.cardTitleText}>
                        <h5 style={FIN.cardTitle}>Roles</h5>
                        <span style={FIN.cardSubtitle}>Create &amp; manage employee roles</span>
                    </div>
                    <div style={FIN.headerActions}>
                        <button style={FIN.btnPrimary} onClick={this.handleCreateRole}>
                            <i className="fas fa-plus" /> Create Role
                        </button>
                    </div>
                </div>

                <div style={FIN.content}>
                    {this.state.loading ? (
                        <TableShimmer cols={4} rows={5} widths={[40, 220, 320, 90]} />
                    ) : this.state.roles.length > 0 ? (
                        <CardLessDataTableWithOutSearch
                            parentData={this.state.roles}
                            particlecolumns={this.articlecolumns}
                        />
                    ) : (
                        <div style={FIN.empty}>
                            <i className="fal fa-user-tag" style={{ fontSize: 30, display: "block", marginBottom: 10, color: "#cbd5e1" }} />
                            No roles yet. Click “Create Role” to add one.
                        </div>
                    )}
                </div>

                <CreateRoleModal
                    show={this.state.roleModalShow}
                    role={this.state.editRole}
                    onHide={() => this.setState({ roleModalShow: false, editRole: null })}
                    onSaved={this.getRoles}
                />

                {/* Shown when a role without is_edit clicks Create Role or an Edit icon. */}
                <AccessDeniedModal
                    show={this.state.accessDeniedShow}
                    onHide={this.guard.hideAccessDenied}
                />
            </div>
        );
    }
}

export default withApollo(RolesTab);
